import { type FC } from 'react'

import arrowCircleUp from '@core/assets/v2/icons/arrows/regular/Icon-ArrowCircleUp-Regular.svg'
import arrowDown from '@core/assets/v2/icons/arrows/regular/Icon-ArrowDown-Regular.svg'
import arrowDownPlus from '@core/assets/v2/icons/arrows/regular/Icon-ArrowDownPlus-Regular.svg'
import arrowLeft from '@core/assets/v2/icons/arrows/regular/Icon-ArrowLeft-Regular.svg'
import arrowNext from '@core/assets/v2/icons/arrows/regular/Icon-ArrowNext-Regular.svg'
import arrowPrevius from '@core/assets/v2/icons/arrows/regular/Icon-ArrowPrevius-Regular.svg'
import arrowReload from '@core/assets/v2/icons/arrows/regular/Icon-ArrowReload-Regular.svg'
import arrowReset from '@core/assets/v2/icons/arrows/regular/Icon-ArrowReset-Regular.svg'
import arrowRight from '@core/assets/v2/icons/arrows/regular/Icon-ArrowRight-Regular.svg'
import arrowUp from '@core/assets/v2/icons/arrows/regular/Icon-ArrowUp-Regular.svg'
import arrowUpPlus from '@core/assets/v2/icons/arrows/regular/Icon-ArrowUpPlus-Regular.svg'
import arrows from '@core/assets/v2/icons/arrows/regular/Icon-Arrows-Regular.svg'
import chevronDownLarge from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Down-Large-Regular.svg'
import chevronDownMedium from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Down-Medium-Regular.svg'
import chevronDownSmall from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Down-Small-Regular.svg'
import chevronLeftLarge from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Left-Large-Regular.svg'
import chevronLeftMedium from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Left-Medium-Regular.svg'
import chevronLeftSmall from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Left-Small-Regular.svg'
import chevronRightLarge from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Right-Large-Regular.svg'
import chevronRightMedium from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Right-Medium-Regular.svg'
import chevronRightSmall from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Right-Small-Regular.svg'
import chevronSkipLeftMedium from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-SkipLeft-Medium-Regular.svg'
import chevronSkipLeftSmall from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-SkipLeft-Small-Regular.svg'
import chevronSkipRightMedium from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-SkipRight-Medium-Regular.svg'
import chevronSkipRightSmall from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-SkipRight-Small-Regular.svg'
import chevronUpLarge from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Up-Large-Regular.svg'
import chevronUpMedium from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Up-Medium-Regular.svg'
import chevronUpSmall from '@core/assets/v2/icons/arrows/regular/Icon-Chevron-Up-Small-Regular.svg'
import collapseChevrons from '@core/assets/v2/icons/arrows/regular/Icon-Collapse-Chevrons-Regular.svg'
import collapse from '@core/assets/v2/icons/arrows/regular/Icon-Collapse-Regular.svg'
import collapseToLeft from '@core/assets/v2/icons/arrows/regular/Icon-CollapseToLeft-Regular.svg'
import collapseToRight from '@core/assets/v2/icons/arrows/regular/Icon-CollapseToRight-Regular.svg'
import collapseToSidebar from '@core/assets/v2/icons/arrows/regular/Icon-CollapseToSidebar.svg'
import conversion from '@core/assets/v2/icons/arrows/regular/Icon-Conversion-Regular.svg'
import curvedArrowLeft from '@core/assets/v2/icons/arrows/regular/Icon-CurvedArrowLeft-Regular.svg'
import download from '@core/assets/v2/icons/arrows/regular/Icon-Download-Regular.svg'
import enter from '@core/assets/v2/icons/arrows/regular/Icon-Enter-Regular.svg'
import expandChevrons from '@core/assets/v2/icons/arrows/regular/Icon-Expand-Chevrons-Regular.svg'
import expand from '@core/assets/v2/icons/arrows/regular/Icon-Expand-Regular.svg'
import expandFromLeft from '@core/assets/v2/icons/arrows/regular/Icon-ExpandFromLeft-Regular.svg'
import expandFromRight from '@core/assets/v2/icons/arrows/regular/Icon-ExpandFromRight-Regular.svg'
import external from '@core/assets/v2/icons/arrows/regular/Icon-External-Regular.svg'
import external2 from '@core/assets/v2/icons/arrows/regular/Icon-External2-Regular.svg'
import forward from '@core/assets/v2/icons/arrows/regular/Icon-Forward-Regular.svg'
import leftPlus from '@core/assets/v2/icons/arrows/regular/Icon-LeftPlus-Regular.svg'
import logIn from '@core/assets/v2/icons/arrows/regular/Icon-LogIn-Regular.svg'
import logOut from '@core/assets/v2/icons/arrows/regular/Icon-LogOut-Regular.svg'
import moveToBottom from '@core/assets/v2/icons/arrows/regular/Icon-MoveToBottom-Regular.svg'
import moveToTop from '@core/assets/v2/icons/arrows/regular/Icon-MoveToTop-Regular.svg'
import pictureInPicture from '@core/assets/v2/icons/arrows/regular/Icon-Picture-in-picture.svg'
import pictureInPictureArrowDown from '@core/assets/v2/icons/arrows/regular/Icon-Picture-in-pictureArrowDown.svg'
import pictureInPictureArrowDown2 from '@core/assets/v2/icons/arrows/regular/Icon-Picture-in-pictureArrowDown2.svg'
import pictureInPictureArrowUp from '@core/assets/v2/icons/arrows/regular/Icon-Picture-in-pictureArrowUp.svg'
import pictureInPictureArrowUp2 from '@core/assets/v2/icons/arrows/regular/Icon-Picture-in-pictureArrowUp2.svg'
import reRun from '@core/assets/v2/icons/arrows/regular/Icon-ReRun-Regular.svg'
import redo from '@core/assets/v2/icons/arrows/regular/Icon-Redo-Regular.svg'
import redoRectangle from '@core/assets/v2/icons/arrows/regular/Icon-RedoRectangle-Regular.svg'
import repeat1 from '@core/assets/v2/icons/arrows/regular/Icon-Repeat-Regular-1.svg'
import repeat from '@core/assets/v2/icons/arrows/regular/Icon-Repeat-Regular.svg'
import replies from '@core/assets/v2/icons/arrows/regular/Icon-Replies-Regular.svg'
import reply from '@core/assets/v2/icons/arrows/regular/Icon-Reply-Regular.svg'
import request from '@core/assets/v2/icons/arrows/regular/Icon-Request-Regular.svg'
import resendEmail from '@core/assets/v2/icons/arrows/regular/Icon-ResendEmail-Regular.svg'
import resendEnvelope from '@core/assets/v2/icons/arrows/regular/Icon-ResendEnvelope-Regular.svg'
import resendEnvelopeInverted from '@core/assets/v2/icons/arrows/regular/Icon-ResendEnvelopeInverted-Regular.svg'
import rightPlus from '@core/assets/v2/icons/arrows/regular/Icon-RightPlus-Regular.svg'
import rotate from '@core/assets/v2/icons/arrows/regular/Icon-Rotate-Regular.svg'
import sort from '@core/assets/v2/icons/arrows/regular/Icon-Sort-Regular.svg'
import sortAZ from '@core/assets/v2/icons/arrows/regular/Icon-Sort-a-z-Regular.svg'
import sortZA from '@core/assets/v2/icons/arrows/regular/Icon-Sort-z-a-Regular.svg'
import swap from '@core/assets/v2/icons/arrows/regular/Icon-Swap-Regular.svg'
import synchronize from '@core/assets/v2/icons/arrows/regular/Icon-Synchronize-Regular.svg'
import transaction from '@core/assets/v2/icons/arrows/regular/Icon-Transaction-Regular.svg'
import transferCircle from '@core/assets/v2/icons/arrows/regular/Icon-Transfer-Circle-Regular.svg'
import transfer from '@core/assets/v2/icons/arrows/regular/Icon-Transfer-Regular.svg'
import undo from '@core/assets/v2/icons/arrows/regular/Icon-Undo-Regular.svg'
import undoRectangle from '@core/assets/v2/icons/arrows/regular/Icon-UndoRectangle-Regular.svg'
import updated from '@core/assets/v2/icons/arrows/regular/Icon-Updated-Regular.svg'
import upload from '@core/assets/v2/icons/arrows/regular/Icon-Upload-Regular.svg'
import arrowLeftSolid from '@core/assets/v2/icons/arrows/solid/Icon-ArrowLeft-Solid.svg'
import arrowReloadSolid from '@core/assets/v2/icons/arrows/solid/Icon-ArrowReload-Solid.svg'
import arrowResetSolid from '@core/assets/v2/icons/arrows/solid/Icon-ArrowReset-Solid.svg'
import arrowRightSolid from '@core/assets/v2/icons/arrows/solid/Icon-ArrowRight-Solid.svg'
import arrowsCollapseSolid from '@core/assets/v2/icons/arrows/solid/Icon-ArrowsCollapse-Solid.svg'
import arrowsExpandSolid from '@core/assets/v2/icons/arrows/solid/Icon-ArrowsExpand-Solid.svg'
import arrowsSolid from '@core/assets/v2/icons/arrows/solid/Icon-Arrows-Solid.svg'
import chevronDownLargeSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Down-Large-Solid.svg'
import chevronDownMediumSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Down-Medium-Solid.svg'
import chevronDownSmallSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Down-Small-Solid.svg'
import chevronDownSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Down-Solid.svg'
import chevronDownSolid1 from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Down-Solid-1.svg'
import chevronLeftLargeSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Left-Large-Solid.svg'
import chevronLeftMediumSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Left-Medium-Solid.svg'
import chevronLeftSmallSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Left-Small-Solid.svg'
import chevronRightLargeSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Right-Large-Solid.svg'
import chevronRightMediumSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Right-Medium-Solid.svg'
import chevronRightSmallSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Right-Small-Solid.svg'
import chevronRightSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Right-Solid.svg'
import chevronUpLargeSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Up-Large-Solid.svg'
import chevronUpMediumSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Up-Medium-Solid.svg'
import chevronUpSmallSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Up-Small-Solid.svg'
import chevronUpSolid from '@core/assets/v2/icons/arrows/solid/Icon-Chevron-Up-Solid.svg'
import collapseChevronsSolid from '@core/assets/v2/icons/arrows/solid/Icon-Collapse-Chevrons-Solid.svg'
import collapseSolid from '@core/assets/v2/icons/arrows/solid/Icon-Collapse-Solid.svg'
import downloadSolid from '@core/assets/v2/icons/arrows/solid/Icon-Download-Solid.svg'
import expandChevronsSolid from '@core/assets/v2/icons/arrows/solid/Icon-Expand-Chevrons-Solid.svg'
import expandSolid from '@core/assets/v2/icons/arrows/solid/Icon-Expand-Solid.svg'
import externalSolid from '@core/assets/v2/icons/arrows/solid/Icon-External-Solid.svg'
import forwardSolid from '@core/assets/v2/icons/arrows/solid/Icon-Forward-Solid.svg'
import logOutSolid from '@core/assets/v2/icons/arrows/solid/Icon-LogOut-Solid.svg'
import replySolid from '@core/assets/v2/icons/arrows/solid/Icon-Reply-Solid.svg'
import sortAZSolid from '@core/assets/v2/icons/arrows/solid/Icon-Sort-a-z-Solid.svg'
import sortSolid from '@core/assets/v2/icons/arrows/solid/Icon-Sort-Solid.svg'
import sortZASolid from '@core/assets/v2/icons/arrows/solid/Icon-Sort-z-a-Solid.svg'
import synchronizeSolid from '@core/assets/v2/icons/arrows/solid/Icon-Synchronize-Solid.svg'
import transactionSolid from '@core/assets/v2/icons/arrows/solid/Icon-Transaction-Solid.svg'
import transferCircleSolid from '@core/assets/v2/icons/arrows/solid/Icon-Transfer-Circle-Solid.svg'
import transferSolid from '@core/assets/v2/icons/arrows/solid/Icon-Transfer-Solid.svg'
import uploadSolid from '@core/assets/v2/icons/arrows/solid/Icon-Upload-Solid.svg'

import { createIcon } from './createIcon'
import type { ArrowIconName, IconProps } from './types'

export const IconArrowCircleUp = createIcon(arrowCircleUp, 'ArrowCircleUp')
export const IconArrowDown = createIcon(arrowDown, 'ArrowDown')
export const IconArrowDownPlus = createIcon(arrowDownPlus, 'ArrowDownPlus')
export const IconArrowLeft = createIcon(arrowLeft, 'ArrowLeft')
export const IconArrowNext = createIcon(arrowNext, 'ArrowNext')
export const IconArrowPrevius = createIcon(arrowPrevius, 'ArrowPrevius')
export const IconArrowReload = createIcon(arrowReload, 'ArrowReload')
export const IconArrowReset = createIcon(arrowReset, 'ArrowReset')
export const IconArrowRight = createIcon(arrowRight, 'ArrowRight')
export const IconArrowUp = createIcon(arrowUp, 'ArrowUp')
export const IconArrowUpPlus = createIcon(arrowUpPlus, 'ArrowUpPlus')
export const IconArrows = createIcon(arrows, 'Arrows')
export const IconChevronDownLarge = createIcon(chevronDownLarge, 'ChevronDownLarge')
export const IconChevronDownMedium = createIcon(chevronDownMedium, 'ChevronDownMedium')
export const IconChevronDownSmall = createIcon(chevronDownSmall, 'ChevronDownSmall')
export const IconChevronLeftLarge = createIcon(chevronLeftLarge, 'ChevronLeftLarge')
export const IconChevronLeftMedium = createIcon(chevronLeftMedium, 'ChevronLeftMedium')
export const IconChevronLeftSmall = createIcon(chevronLeftSmall, 'ChevronLeftSmall')
export const IconChevronRightLarge = createIcon(chevronRightLarge, 'ChevronRightLarge')
export const IconChevronRightMedium = createIcon(chevronRightMedium, 'ChevronRightMedium')
export const IconChevronRightSmall = createIcon(chevronRightSmall, 'ChevronRightSmall')
export const IconChevronSkipLeftMedium = createIcon(chevronSkipLeftMedium, 'ChevronSkipLeftMedium')
export const IconChevronSkipLeftSmall = createIcon(chevronSkipLeftSmall, 'ChevronSkipLeftSmall')
export const IconChevronSkipRightMedium = createIcon(chevronSkipRightMedium, 'ChevronSkipRightMedium')
export const IconChevronSkipRightSmall = createIcon(chevronSkipRightSmall, 'ChevronSkipRightSmall')
export const IconChevronUpLarge = createIcon(chevronUpLarge, 'ChevronUpLarge')
export const IconChevronUpMedium = createIcon(chevronUpMedium, 'ChevronUpMedium')
export const IconChevronUpSmall = createIcon(chevronUpSmall, 'ChevronUpSmall')
export const IconCollapseChevrons = createIcon(collapseChevrons, 'CollapseChevrons')
export const IconCollapse = createIcon(collapse, 'Collapse')
export const IconCollapseToLeft = createIcon(collapseToLeft, 'CollapseToLeft')
export const IconCollapseToRight = createIcon(collapseToRight, 'CollapseToRight')
export const IconCollapseToSidebar = createIcon(collapseToSidebar, 'CollapseToSidebar')
export const IconConversion = createIcon(conversion, 'Conversion')
export const IconCurvedArrowLeft = createIcon(curvedArrowLeft, 'CurvedArrowLeft')
export const IconDownload = createIcon(download, 'Download')
export const IconEnter = createIcon(enter, 'Enter')
export const IconExpandChevrons = createIcon(expandChevrons, 'ExpandChevrons')
export const IconExpand = createIcon(expand, 'Expand')
export const IconExpandFromLeft = createIcon(expandFromLeft, 'ExpandFromLeft')
export const IconExpandFromRight = createIcon(expandFromRight, 'ExpandFromRight')
export const IconExternal = createIcon(external, 'External')
export const IconExternal2 = createIcon(external2, 'External2')
export const IconForward = createIcon(forward, 'Forward')
export const IconLeftPlus = createIcon(leftPlus, 'LeftPlus')
export const IconLogIn = createIcon(logIn, 'LogIn')
export const IconLogOut = createIcon(logOut, 'LogOut')
export const IconMoveToBottom = createIcon(moveToBottom, 'MoveToBottom')
export const IconMoveToTop = createIcon(moveToTop, 'MoveToTop')
export const IconPictureInPicture = createIcon(pictureInPicture, 'PictureInPicture')
export const IconPictureInPictureArrowDown = createIcon(pictureInPictureArrowDown, 'PictureInPictureArrowDown')
export const IconPictureInPictureArrowDown2 = createIcon(pictureInPictureArrowDown2, 'PictureInPictureArrowDown2')
export const IconPictureInPictureArrowUp = createIcon(pictureInPictureArrowUp, 'PictureInPictureArrowUp')
export const IconPictureInPictureArrowUp2 = createIcon(pictureInPictureArrowUp2, 'PictureInPictureArrowUp2')
export const IconReRun = createIcon(reRun, 'ReRun')
export const IconRedo = createIcon(redo, 'Redo')
export const IconRedoRectangle = createIcon(redoRectangle, 'RedoRectangle')
export const IconRepeat1 = createIcon(repeat1, 'Repeat1')
export const IconRepeat = createIcon(repeat, 'Repeat')
export const IconReplies = createIcon(replies, 'Replies')
export const IconReply = createIcon(reply, 'Reply')
export const IconRequest = createIcon(request, 'Request')
export const IconResendEmail = createIcon(resendEmail, 'ResendEmail')
export const IconResendEnvelope = createIcon(resendEnvelope, 'ResendEnvelope')
export const IconResendEnvelopeInverted = createIcon(resendEnvelopeInverted, 'ResendEnvelopeInverted')
export const IconRightPlus = createIcon(rightPlus, 'RightPlus')
export const IconRotate = createIcon(rotate, 'Rotate')
export const IconSort = createIcon(sort, 'Sort')
export const IconSortAZ = createIcon(sortAZ, 'SortAZ')
export const IconSortZA = createIcon(sortZA, 'SortZA')
export const IconSwap = createIcon(swap, 'Swap')
export const IconSynchronize = createIcon(synchronize, 'Synchronize')
export const IconTransaction = createIcon(transaction, 'Transaction')
export const IconTransferCircle = createIcon(transferCircle, 'TransferCircle')
export const IconTransfer = createIcon(transfer, 'Transfer')
export const IconUndo = createIcon(undo, 'Undo')
export const IconUndoRectangle = createIcon(undoRectangle, 'UndoRectangle')
export const IconUpdated = createIcon(updated, 'Updated')
export const IconUpload = createIcon(upload, 'Upload')
export const IconArrowLeftSolid = createIcon(arrowLeftSolid, 'ArrowLeftSolid')
export const IconArrowReloadSolid = createIcon(arrowReloadSolid, 'ArrowReloadSolid')
export const IconArrowResetSolid = createIcon(arrowResetSolid, 'ArrowResetSolid')
export const IconArrowRightSolid = createIcon(arrowRightSolid, 'ArrowRightSolid')
export const IconArrowsCollapseSolid = createIcon(arrowsCollapseSolid, 'ArrowsCollapseSolid')
export const IconArrowsExpandSolid = createIcon(arrowsExpandSolid, 'ArrowsExpandSolid')
export const IconArrowsSolid = createIcon(arrowsSolid, 'ArrowsSolid')
export const IconChevronDownLargeSolid = createIcon(chevronDownLargeSolid, 'ChevronDownLargeSolid')
export const IconChevronDownMediumSolid = createIcon(chevronDownMediumSolid, 'ChevronDownMediumSolid')
export const IconChevronDownSmallSolid = createIcon(chevronDownSmallSolid, 'ChevronDownSmallSolid')
export const IconChevronDownSolid = createIcon(chevronDownSolid, 'ChevronDownSolid')
export const IconChevronDownSolid1 = createIcon(chevronDownSolid1, 'ChevronDownSolid1')
export const IconChevronLeftLargeSolid = createIcon(chevronLeftLargeSolid, 'ChevronLeftLargeSolid')
export const IconChevronLeftMediumSolid = createIcon(chevronLeftMediumSolid, 'ChevronLeftMediumSolid')
export const IconChevronLeftSmallSolid = createIcon(chevronLeftSmallSolid, 'ChevronLeftSmallSolid')
export const IconChevronRightLargeSolid = createIcon(chevronRightLargeSolid, 'ChevronRightLargeSolid')
export const IconChevronRightMediumSolid = createIcon(chevronRightMediumSolid, 'ChevronRightMediumSolid')
export const IconChevronRightSmallSolid = createIcon(chevronRightSmallSolid, 'ChevronRightSmallSolid')
export const IconChevronRightSolid = createIcon(chevronRightSolid, 'ChevronRightSolid')
export const IconChevronUpLargeSolid = createIcon(chevronUpLargeSolid, 'ChevronUpLargeSolid')
export const IconChevronUpMediumSolid = createIcon(chevronUpMediumSolid, 'ChevronUpMediumSolid')
export const IconChevronUpSmallSolid = createIcon(chevronUpSmallSolid, 'ChevronUpSmallSolid')
export const IconChevronUpSolid = createIcon(chevronUpSolid, 'ChevronUpSolid')
export const IconCollapseChevronsSolid = createIcon(collapseChevronsSolid, 'CollapseChevronsSolid')
export const IconCollapseSolid = createIcon(collapseSolid, 'CollapseSolid')
export const IconDownloadSolid = createIcon(downloadSolid, 'DownloadSolid')
export const IconExpandChevronsSolid = createIcon(expandChevronsSolid, 'ExpandChevronsSolid')
export const IconExpandSolid = createIcon(expandSolid, 'ExpandSolid')
export const IconExternalSolid = createIcon(externalSolid, 'ExternalSolid')
export const IconForwardSolid = createIcon(forwardSolid, 'ForwardSolid')
export const IconLogOutSolid = createIcon(logOutSolid, 'LogOutSolid')
export const IconReplySolid = createIcon(replySolid, 'ReplySolid')
export const IconSortAZSolid = createIcon(sortAZSolid, 'SortAZSolid')
export const IconSortSolid = createIcon(sortSolid, 'SortSolid')
export const IconSortZASolid = createIcon(sortZASolid, 'SortZASolid')
export const IconSynchronizeSolid = createIcon(synchronizeSolid, 'SynchronizeSolid')
export const IconTransactionSolid = createIcon(transactionSolid, 'TransactionSolid')
export const IconTransferCircleSolid = createIcon(transferCircleSolid, 'TransferCircleSolid')
export const IconTransferSolid = createIcon(transferSolid, 'TransferSolid')
export const IconUploadSolid = createIcon(uploadSolid, 'UploadSolid')

export const arrowIcons: Record<ArrowIconName, FC<IconProps>> = {
    ArrowCircleUp: IconArrowCircleUp,
    ArrowDown: IconArrowDown,
    ArrowDownPlus: IconArrowDownPlus,
    ArrowLeft: IconArrowLeft,
    ArrowNext: IconArrowNext,
    ArrowPrevius: IconArrowPrevius,
    ArrowReload: IconArrowReload,
    ArrowReset: IconArrowReset,
    ArrowRight: IconArrowRight,
    ArrowUp: IconArrowUp,
    ArrowUpPlus: IconArrowUpPlus,
    Arrows: IconArrows,
    ChevronDownLarge: IconChevronDownLarge,
    ChevronDownMedium: IconChevronDownMedium,
    ChevronDownSmall: IconChevronDownSmall,
    ChevronLeftLarge: IconChevronLeftLarge,
    ChevronLeftMedium: IconChevronLeftMedium,
    ChevronLeftSmall: IconChevronLeftSmall,
    ChevronRightLarge: IconChevronRightLarge,
    ChevronRightMedium: IconChevronRightMedium,
    ChevronRightSmall: IconChevronRightSmall,
    ChevronSkipLeftMedium: IconChevronSkipLeftMedium,
    ChevronSkipLeftSmall: IconChevronSkipLeftSmall,
    ChevronSkipRightMedium: IconChevronSkipRightMedium,
    ChevronSkipRightSmall: IconChevronSkipRightSmall,
    ChevronUpLarge: IconChevronUpLarge,
    ChevronUpMedium: IconChevronUpMedium,
    ChevronUpSmall: IconChevronUpSmall,
    CollapseChevrons: IconCollapseChevrons,
    Collapse: IconCollapse,
    CollapseToLeft: IconCollapseToLeft,
    CollapseToRight: IconCollapseToRight,
    CollapseToSidebar: IconCollapseToSidebar,
    Conversion: IconConversion,
    CurvedArrowLeft: IconCurvedArrowLeft,
    Download: IconDownload,
    Enter: IconEnter,
    ExpandChevrons: IconExpandChevrons,
    Expand: IconExpand,
    ExpandFromLeft: IconExpandFromLeft,
    ExpandFromRight: IconExpandFromRight,
    External: IconExternal,
    External2: IconExternal2,
    Forward: IconForward,
    LeftPlus: IconLeftPlus,
    LogIn: IconLogIn,
    LogOut: IconLogOut,
    MoveToBottom: IconMoveToBottom,
    MoveToTop: IconMoveToTop,
    PictureInPicture: IconPictureInPicture,
    PictureInPictureArrowDown: IconPictureInPictureArrowDown,
    PictureInPictureArrowDown2: IconPictureInPictureArrowDown2,
    PictureInPictureArrowUp: IconPictureInPictureArrowUp,
    PictureInPictureArrowUp2: IconPictureInPictureArrowUp2,
    ReRun: IconReRun,
    Redo: IconRedo,
    RedoRectangle: IconRedoRectangle,
    Repeat1: IconRepeat1,
    Repeat: IconRepeat,
    Replies: IconReplies,
    Reply: IconReply,
    Request: IconRequest,
    ResendEmail: IconResendEmail,
    ResendEnvelope: IconResendEnvelope,
    ResendEnvelopeInverted: IconResendEnvelopeInverted,
    RightPlus: IconRightPlus,
    Rotate: IconRotate,
    Sort: IconSort,
    SortAZ: IconSortAZ,
    SortZA: IconSortZA,
    Swap: IconSwap,
    Synchronize: IconSynchronize,
    Transaction: IconTransaction,
    TransferCircle: IconTransferCircle,
    Transfer: IconTransfer,
    Undo: IconUndo,
    UndoRectangle: IconUndoRectangle,
    Updated: IconUpdated,
    Upload: IconUpload,
    ArrowLeftSolid: IconArrowLeftSolid,
    ArrowReloadSolid: IconArrowReloadSolid,
    ArrowResetSolid: IconArrowResetSolid,
    ArrowRightSolid: IconArrowRightSolid,
    ArrowsCollapseSolid: IconArrowsCollapseSolid,
    ArrowsExpandSolid: IconArrowsExpandSolid,
    ArrowsSolid: IconArrowsSolid,
    ChevronDownLargeSolid: IconChevronDownLargeSolid,
    ChevronDownMediumSolid: IconChevronDownMediumSolid,
    ChevronDownSmallSolid: IconChevronDownSmallSolid,
    ChevronDownSolid: IconChevronDownSolid,
    ChevronDownSolid1: IconChevronDownSolid1,
    ChevronLeftLargeSolid: IconChevronLeftLargeSolid,
    ChevronLeftMediumSolid: IconChevronLeftMediumSolid,
    ChevronLeftSmallSolid: IconChevronLeftSmallSolid,
    ChevronRightLargeSolid: IconChevronRightLargeSolid,
    ChevronRightMediumSolid: IconChevronRightMediumSolid,
    ChevronRightSmallSolid: IconChevronRightSmallSolid,
    ChevronRightSolid: IconChevronRightSolid,
    ChevronUpLargeSolid: IconChevronUpLargeSolid,
    ChevronUpMediumSolid: IconChevronUpMediumSolid,
    ChevronUpSmallSolid: IconChevronUpSmallSolid,
    ChevronUpSolid: IconChevronUpSolid,
    CollapseChevronsSolid: IconCollapseChevronsSolid,
    CollapseSolid: IconCollapseSolid,
    DownloadSolid: IconDownloadSolid,
    ExpandChevronsSolid: IconExpandChevronsSolid,
    ExpandSolid: IconExpandSolid,
    ExternalSolid: IconExternalSolid,
    ForwardSolid: IconForwardSolid,
    LogOutSolid: IconLogOutSolid,
    ReplySolid: IconReplySolid,
    SortAZSolid: IconSortAZSolid,
    SortSolid: IconSortSolid,
    SortZASolid: IconSortZASolid,
    SynchronizeSolid: IconSynchronizeSolid,
    TransactionSolid: IconTransactionSolid,
    TransferCircleSolid: IconTransferCircleSolid,
    TransferSolid: IconTransferSolid,
    UploadSolid: IconUploadSolid,
}
